import DisclosureItemList from "./SelectionColumns/DisclosureItemList";
import CategoryItemList from "./SelectionColumns/CategoryItemList";
import TopicItemList from "./SelectionColumns/TopicItemList";

import { useDisclosureStore, useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";
import CompanyItemList from "./SelectionColumns/CompanyItemList";

const ViewSelect = () => {
    const isAllDisclosuresAvailable = useDisclosureStore(state => state.isAllDisclosuresAvailable);
    const itemColStyle =
        "w-[17.5rem] p-2 border border-y-0 border-l-0 border-r-[rgba(166, 160, 155, 0.20)] overflow-y-auto";
    const activeTab = useTabStore(state => state.tab);
    const showCompanyList = activeTab?.key === SEARCH_TABS.FULL_DOCUMENTS;

    if (showCompanyList) {
        return (
            <div className="flex h-full">
                <div className="flex-1 h-full p-2 overflow-y-auto">
                    <CompanyItemList />
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-full">
            {isAllDisclosuresAvailable && (
                <div className={itemColStyle}>
                    <DisclosureItemList />
                </div>
            )}

            <div className={itemColStyle}>
                <CategoryItemList />
            </div>

            <div className="flex-1 h-full p-2 overflow-y-auto">
                <TopicItemList />
            </div>
        </div>
    );
};

export default ViewSelect;
